class SystemOne {
    constructor() {
        this.context = null;
        this.pageActive = {};
    }

    start(page) {
        this.pageActive[page] = true;
        this[page]();
        this.context.removeClass('animate-out');
    }

    reset(page) {
        this.pageActive[page] = false;
        this.context.removeClass('animate-in');
        this.context.addClass('animate-out');
        this.context.find('.active').removeClass('active');
    }

    systemOne1() {
        this.context = $('.section-page__system1');
        this.context.addClass('animate-in');
        this.context.find('.obj6-1-tit').addClass('active');
        this.context.find('.obj6-1-txt1').addClass('active');
        this.context.find('.obj6-1-banner1').addClass('active');
        this.context.find('.obj6-1-chr1').addClass('active');
        this.context.find('.obj6-1-chr2').addClass('active');
        this.context.find('.obj6-1-chr3').addClass('active');
        this.context.find('.obj6-1-chr4').addClass('active');
    }
}

export default SystemOne;


// WEBPACK FOOTER //
// ./history/2017/171206_flamedragon/_src/js/page/systemOne.js